export default {
    // title 
    titleMarketUpdates: 'マーケットアップデート',
    titleTrendingCompanies: 'トレンド企業',
    titleInvite: "招待して報酬を獲得",
    titleOnboarding: "オンボーディングキット",


    exportingLeadsToACSV: "CSVへのリードのエクスポートには{count}クレジットを使用します。|CSVへのリードのエクスポートには{count}クレジットを使用します。",
    

    // trending companies

    // invite
    forReferrals: "紹介の場合：",
    inviteBtn: '招待',
    copyLink: 'リンクをコピー',
    shareYourReferralLink: '紹介リンクを共有するか、メールアドレスを入力して他の人を招待しましょう。参加すると報酬を獲得できます！',
    forTeamInvites: "チーム招待の場合（クレジット獲得のため）：",
    assignTeamInvites: "チーム招待を割り当てる",
    lookingToGrowYourTeam: "チームを成長させたいですか？招待を割り当てて、誰かが参加するたびにクレジットを獲得し始めましょう！",
    addMultipleAddresses: "複数のアドレスをカンマで区切って追加する",
    greatProgress: "素晴らしい進捗です！引き続き招待して、{count}クレジットをすべてアンロックしましょう。",
    startInviting: '招待を開始して、最大{count}クレジットを獲得しましょう！',
    allSet: "すべて完了です！{count}クレジットを獲得しました。ご招待いただきありがとうございます！",


    // custom insight
    addYourOwnCustomInsights: "独自のカスタムインサイトを追加",
    companyKeyMilestones: "会社の主要なマイルストーン",
    listMajorCompetitors: "同じ業界の主要な競合他社をリストアップ",
    analyzeMarketPresence: "会社の市場での存在感を分析する",
    poweredByAi: "AI搭載",

    // onboarding kit
    grantedUponCompletion: '完了時に{count}が付与されます',
    granted_complete: '{count} クレジットのボーナスが付与されました！',


    // ai
    meetRonnaAi: "RonnaAiのご紹介 - スマートビジネスアシスタント",
    askAnything: "何でも質問してください...",
    askQuestionsExploreStrategies: '質問したり、戦略を探求したり、あなたに合わせたインサイトを即座に得ることができます。',
    limitedView: "限定表示",
    viewFullCompanyDetails: "会社の詳細をすべて表示",
    recentThreads: "最近のスレッド",
    recentlyViewed: "最近表示したもの",
    companyAndWebsite: "企業 / ウェブサイト",
    noResultsAskAi: "結果がありませんか？RonnaAIに関連情報を尋ねてみましょう",
    allSearchResultsFor: "{count}のすべての検索結果",
    searchForAnything: "何かを検索",
    pressEnter: "ENTERを押してください",
    askRonnaAI: "RonnaAIに質問する：",
    clickToChatWithRonnaAI: "クリックしてRonnaAIとチャットし、詳細情報を得る",
    useRonnaAIToExploreBusinessDirectories: "RonnaAIを使用して、ビジネスディレクトリ、インサイトなどを即座に探索します。",
    ronnaAI: 'RonnaAI',
    findSearchHistory: "検索履歴を探す",
    Today: '今日',
    "7 Days": "7日間",
    '30 Days': "その他",
    deleteRecord: "記録を削除",
    newChat: "新しいチャット",
    aiTabAnswer: "回答",
    aiTabCompanies: "企業",
    aiTabSources: "ソース",
    processingYourRequest: "リクエストを処理中...",
    thinkingDeeply: "深く考えています",
    generatingAPlan: "計画を作成中",
    noHistoryYet: "まだ履歴はありません",

    // advertisement
    targetLocation: "ターゲットロケーション",
    open_ad: "広告を開く",
    est_impressions: "推定インプレッション",
    ads: "広告",

    // expansion signals (Phase 1)
    expansion: {
        jobsInsights: {
            heading: "採用状況",
            windowReadout: "過去 {n} 日",
            windowHint: "この期間に募集中の求人を集計",
            kpiOpen: "募集中の求人",
            kpiPosted: "掲載求人",
            openSub: "募集中 計 {n} 件",
            kpiPace: "採用ペース",
            kpiTopFunction: "主な職種",
            kpiMarkets: "対象地域",
            newSub: "新規 {n} 件",
            trendVsPrior: "前期比",
            marketShare: "{pct}% {place}",
            nRoles: "{n} 件の求人",
            momentumLabel: "採用の勢い",
            velAccel: "加速中",
            velSlow: "減速中",
            velSteady: "横ばい",
            mover: "{flag} {place} — 過去1か月で {n} 件",
            moverSenior: "{flag} {place} — 過去1か月で {n} 件、多くは {tier}",
            moverNew: "· 新市場",
            exploreLabel: "探索",
            exploreHint: "バーをタップ — 職種・地域・役職のつながりを見る",
            showingOf: "{total} 件中 {n} 件",
            clearAll: "クリア",
            listFilteredBy: "絞り込み：",
            notClassified: "{n} 件は未分類",
            openListTitle: "掲載求人",
            openListNote: "掲載 · {window}",
            leadTopFunction: "{label} が最多 — {count} 件",
            leadTopLocation: "{pct}% が {place}",
            tier_executive: "役員",
            tier_director: "部長クラス",
            tier_manager: "マネージャー",
            tier_senior: "シニア",
            tier_junior: "ジュニア",
            byFunction: "職種別",
            byLocation: "地域別",
            bySeniority: "役職レベル別",
            thisCompany: "この企業",
            narrFast: "{company} は急成長中——過去 {days} 日で {n} 件の求人を公開し、前期比 {pct}% 増。",
            narrUp: "{company} は積極的に採用中——過去 {days} 日で {n} 件の新規求人、前期比 {pct}% 増。",
            narrSteady: "{company} の採用は横ばい——過去 {days} 日で {n} 件の求人、前期と同水準。",
            narrDown: "{company} の採用は減速——過去 {days} 日で {n} 件の求人、前期比 {pct}% 減。",
            narrQuiet: "{company} は {open} 件の求人がありますが、最近の新規公開は少なめです。",
            narrMix: "{fn} 中心で、{loc} に集中。",
            narrMixSenior: "{fn} 中心で、{loc} に集中。うち {pct}% が管理職。",
            loadError: "採用インサイトを読み込めませんでした",
            retry: "再試行",
            none: "—",
        },
        adsInsights: {
            eyebrow: "広告アクティビティ",
            openListTitle: "配信中の広告",
            lead: "{markets} 市場で配信中のキャンペーン {n} 件",
            kpiActive: "配信中の広告",
            kpiMarkets: "対象市場",
            kpiTopChannel: "主要チャネル",
            kpiTopFormat: "主なフォーマット",
            leadReach: "最大 {reach} にリーチ",
            kpiMomentum: "勢い",
            windowSub: "過去 {n} 日",
            trendVsPrior: "前期比",
            sparkLabel: "広告の開始",
            moreInsights: "詳細を表示",
            lessInsights: "詳細を隠す",
            byReach: "リーチ別（インプレッション）",
            reach_lt_1k: "1千未満",
            reach_1k_10k: "1千〜1万",
            reach_10k_50k: "1万〜5万",
            reach_50k_100k: "5万〜10万",
            reach_100k_500k: "10万〜50万",
            reach_500k_1m: "50万〜100万",
            reach_1m_plus: "100万+",
            reachPeak: "ピーク {peak}",
            byMarket: "対象市場別",
            byChannel: "チャネル別",
            byFormat: "フォーマット別",
            byPlacement: "配置先別",
            exploreLabel: "探索",
            exploreHint: "バーをタップ — リーチ・市場・チャネルの関係を確認",
            exploringOf: "最近 {total} 件中 {n} 件を探索中",
            showingOf: "{total} 件中 {n} 件の広告",
            clearAll: "クリア",
            leadTopMarket: "{pct}% が {place} を狙う",
            leadTopChannel: "{pct}% が {channel} 経由",
            noImpression: "これらの広告にインプレッションデータなし",
            noImpressionN: "{n} 件はインプレッションデータなし",
            noMarket: "ターゲット市場データなし",
            noMarketN: "{n} 件はターゲット市場なし",
            marketLed: "主に {place}",
            creatives: "最近のクリエイティブ",
            nCampaigns: "{n} 件の広告",
            loadError: "広告インサイトを読み込めませんでした",
            retry: "再試行",
            none: "—",
        },
        newsInsights: {
            eyebrow: "メディアと動向",
            lead: "過去 {days} 日間で {n} 件の言及",
            kpiMentions: "言及数",
            kpiMomentum: "勢い",
            kpiPositive: "拡大シグナル",
            kpiRisk: "リスクシグナル",
            windowSub: "過去 {n} 日",
            trendVsPrior: "前期比",
            sparkLabel: "報道量",
            fundingLatest: "最新の資金調達",
            moreInsights: "詳細を表示",
            lessInsights: "詳細を隠す",
            byTopic: "トピック別",
            loadError: "メディアインサイトを読み込めませんでした",
            retry: "再試行",
            none: "—",
        },
        pitch: {
            headline: "Pubrio · 新しい国へ進出する企業を発見。",
            body: "毎日、何千もの企業が新しい市場へ参入しています。最後ではなく、最初に連絡する企業になりましょう。",
            dismiss: "閉じる",
        },
        kpi: {
            title: "主要な拡大指標",
            mostActiveMarket: "最もアクティブな市場",
            yourFocus: "注目市場",
            companiesInWindow: "{n}社が新規シグナルあり · {window}",
            bestToContact: "今すぐ連絡すべき",
            inLandingStage: "着地ステージ",
            movingUnusuallyFast: "異例の速さで進行中",
            aheadOfPace: "通常ペースを上回る",
            hot: "ホット",
            newActivity: "新規アクティビティシグナル",
            activeMarkets: "アクティブな市場",
            thisWeek: "今週",
            last30Days: "過去30日間",
            movementHeadline: "この期間の新規アクティビティ",
            movementHint: "{total}市場中{active}市場",
            // Tile 2-4 hint suffixes — GLOBAL mode appends a country chip,
            // SELECTED mode reuses tile 1's focus country and drops the chip.
            hintOfMarket: "市場の{rate}",
            hintOfFocus: "{country}企業の{rate}",
            hintAheadOfPaceGlobal: "{rate}が通常ペースを上回る",
            hintAheadOfPaceFocus: "{country}企業の{rate}が通常ペースを上回る",
            hintNewThisWeekGlobal: "今週{rate}が新規",
            hintNewThisWeekFocus: "{country}企業の{rate}が今週新規",
            // Empty state for SELECTED mode when the picked country has no data
            // in the active date window.
            noDataInWindow: "この期間にはまだシグナルがありません",
        },
        competitive: {
            heading: "競合の拡大比較",
            subCurated: "{name} の海外展開を競合各社と比較",
            comparingAgainst: "比較対象",
            addCompetitor: "競合を追加",
            addSearching: "検索中…",
            addEmpty: "企業が見つかりません",
            removeCompetitor: "削除",
            takeawayLead: "{metric}で、{name} は競合 {n} 社をリードしています。",
            takeawayRank: "{metric}で、{name} は競合 {total} 社中 {rank} 位です。",
            colCompany: "企業",
            colMarket: "市場",
            colActiveMarkets: "市場",
            colNewMarkets: "新市場",
            colMomentumPct: "勢い",
            colSignalCount: "活動量",
            colExpansionScore: "拡大スコア",
            colIndustry: "業界",
            colCountry: "本社",
            colEmployees: "従業員数",
            colFounded: "設立年",
            colTopMarket: "主要進出先",
            colNewestMarket: "最新参入",
            colOperating: "運用中",
            colPipeline: "パイプライン",
            colMatch: "類似度",
            columns: "列",
            columnsHint: "比較する項目を追加",
            fieldsGroupExpansion: "拡大指標",
            fieldsGroupCompany: "企業情報",
            you: "自社",
            openCompany: "企業を開く",
            pendingHint: "拡大データを読み込み中",
            empty: "拡大データを持つ競合がまだありません。",
            cellSignals: "{n} シグナル",
            hoverHint: "市場指標にカーソルを合わせると、実際の国が表示されます。",
            coverageTitle: "市場カバレッジ",
            coverageSub: "各競合がどの市場でどこまで進出しているか — {total} 市場のうち {gaps} は競合が進出済みであなたが未進出。",
            covAll: "すべて",
            covGaps: "空白",
            covYours: "自社",
            watch: "市場をウォッチ",
            fieldCaption: "バーは相対的な規模、ミニチャートは各競合の週次アクティビティ推移。",
            legendStage: "色 = ステージ",
            legendRecent: "最近活動あり",
            covYouHint: "背景色 = 自社",
            coverageCount: "{total} 社中 {n} 社が進出",
            cellTypes: "シグナル種別",
            cellSince: "初回検出",
            cellActive: "{t}に活動",
            sortLabel: "市場を並び替え",
            covSortCoverage: "カバレッジ",
            covSortRecent: "最近",
            searchMarket: "市場を検索…",
            noMarkets: "条件に一致する市場がありません。",
        },
        verdict: {
            newMarkets: "新市場",
            momentum: "勢い",
            expansionScore: "拡大スコア",
            vsPrior: "前期比",
            noneThisPeriod: "この期間はなし",
            highConfidenceN: "{n}件の高信頼度",
            mostlyEarly: "ほとんどが初期シグナル",
            scoreVeryStrong: "非常に強い",
            scoreStrong: "強い",
            scoreDeveloping: "発展中",
            scoreEarly: "初期段階",
            signalsInWindow: "{count}シグナル · {window} | {count}シグナル · {window}",
        },
        summary: {
            heading: "グローバル拡大",
            subheading: "この企業が事業を展開している地域と、進出を進めている市場。",
            subheadingCount: "世界{n}市場にわたって — どこで始まり、今どこで成長しているか。",
            founded: "設立年",
            employees: "従業員数",
            markets: "市場",
            marketsHintFrom: "{hq}から拡大中",
            marketsHintWorldwide: "世界規模での展開",
            furthestStage: "最も進んだステージ",
            movingNow: "現在進行中",
            movingNowHint: "過去90日間に進展",
            upToMarkets: "最大{n}市場",
            stages: "ステージ",
            loading: "拡大情報を読み込み中…",
            empty: "この企業の拡大シグナルはまだ追跡されていません。",
            // Enriched no-data / load-error states (the map + feed surface).
            emptyTitle: "拡大シグナルを待機中",
            emptyDetail: "表示できる情報はまだありません。{company}が新しい市場で採用、ニュース発信、広告出稿を行うと、シグナルがここに表示されます。",
            thisCompany: "この企業",
            established: "確立済み",
            establishedTip: "これらの市場で事業を展開 — 新たな拡大活動はありません",
            establishedNote: "{company} は {n} の市場で事業を確立しています — この期間に新たな拡大活動はありません。",
            errorTitle: "シグナルサービスに接続できませんでした",
            errorDetail: "ただ今、拡大データを読み込めませんでした。通常は一時的なものです — もう一度お試しください。",
            retry: "再試行",
            // Command-bar button hover tooltips — every control gets a consistent hint.
            tipMarket: "市場で絞り込む",
            tipDate: "期間を変更する",
            tipStage: "ライフサイクルステージで絞り込む",
            tipExport: "この企業をエクスポート",
            tipClear: "すべてのフィルターをクリア",
            // Insight line under the "Global expansion" heading.
            insight: "{total}市場にわたる · {year}年に{market}へ初進出 · 過去90日間に{moving}件が進展",
            insightNoFirst: "{total}市場にわたる · 過去90日間に{moving}件が進展",
            // Time-scope segmented control.
            timeAll: "全期間",
            time12m: "12ヶ月",
            time6m: "6ヶ月",
            time3m: "3ヶ月",
            // Market-focus filter — narrows the map + entry timeline to chosen markets.
            filterFocus: "注目市場",
            filterAll: "全市場",
            filterMore: "+{n}件",
            filterClear: "クリア",
            filterShowing: "{total}市場中{n}市場",
        },
        // Activity pulse — "what they're doing now" across all markets (ActivityPulse.vue).
        pulse: {
            heading: "アクティビティパルス",
            windowHint: "期間は上部の日付フィルターに従います",
            catHiring: "採用",
            catMarketing: "マーケティング & PR",
            catProduct: "プロダクト & 技術",
            catFootprint: "拠点",
            catPartners: "パートナーシップ",
            leadMore: "{type} +{n}",
            leadNone: "アクティビティなし",
            trendNew: "新規",
            trendSteady: "安定",
            trendEnded: "終了",
            recentEvents: "最近のイベント",
            headcountReduction: "人員削減",
            postingCount: "同じ役職の求人 {n} 件",
            loadMore: "さらに読み込む",
            loadingMore: "読み込み中…",
            viewSource: "ソースを表示",
            via: "{source}経由",
            sourceNews: "ニュース",
            sourceJobs: "求人",
            sourceAds: "広告",
            focusMarket: "フィードで{market}に注目",
            drillSub: "{n}シグナル · {types}種類がアクティブ",
            hQuiet: "全市場で静かな状態 — この期間にシグナルはありません。",
            hNew: "新しい{category}のアクティビティ — {n}件の新規シグナルが出現しました。",
            hRising: "{category}が加速中 — 前期比{pct}%増加。",
            hTop: "{category}で最も活発 — {type}が牽引({n}シグナル)。",
            hTopPlain: "{category}で最も活発 — {n}シグナル。",
        },
        // Stage-distribution bar on the company-detail page (ExpansionPortfolioBar.vue).
        portfolio: {
            heading: "拡大ポートフォリオ",
            markets: "市場",
        },
        // Per-market journey list on the company-detail page (MarketTimeline.vue).
        timeline: {
            heading: "市場参入タイムライン",
            subEntry: "この企業が各市場に参入した順序 — 古い順から新しい順へ",
            subMomentum: "直近のステージの勢いで市場をランク付け",
            byEntry: "参入順",
            byMomentum: "勢い順",
            signals: "シグナル",
            signalTypes: "シグナル種類",
            stageUp: "ステージアップ · {when}",
            stageUpToday: "ステージアップ · 本日",
            now: "現在",
            firstSignal: "最初のシグナルを検出",
            longEstablished: "長期確立済み",
            ordinalEntered: "{ord}番目に参入した市場",
            trackedDays: "{n}日間追跡",
            trackedMonths: "{n}ヶ月間追跡",
            trackedYears: "{n}年間追跡",
            confidence: "信頼度{n}%",
            empty: "このフィルターに一致する市場はありません。",
            showAll: "すべて表示({n})",
            showLess: "折りたたむ",
        },
        // Per-market signal feed on the company-detail page (SignalFeed.vue).
        feed: {
            signalsIn: "市場内のシグナル",
            signals: "シグナル",
            via: "{source}経由",
            reached: "{stage}に到達",
            firstSignal: "最初のシグナル",
            show: "{n}件を表示",
            hide: "非表示",
            empty: "この市場ではまだシグナルが検出されていません。",
            emptyHint: "地図上で別の市場を選ぶか、期間を広げてより多くのアクティビティを表示してください。",
            // No market chosen yet — invite a pick (vs. filters that cleared every market).
            pickTitle: "市場を選択",
            pickHint: "タイムライン上の任意の市場を選んで、そのシグナルを確認してください。",
            noMarketsTitle: "表示する市場がありません",
            noMarketsHint: "フィルターを調整して市場を再表示してください。",
            loadMore: "さらにシグナルを読み込む",
        },
        // Markets "first / now" rail on the company-detail page (JourneyRail.vue).
        journey: {
            wentFirst: "最初に参入",
            wentFirstSub: "拡大した順序で",
            movingNow: "現在進行中",
            movingNowSub: "直近のステージの勢い",
            none: "拡大市場はまだありません",
            showAll: "すべて表示({n})",
            showLess: "折りたたむ",
        },
        dateRange: {
            today: "今日",
            last7: "過去7日間",
            last30: "過去30日間",
            last90: "過去90日間",
            last12m: "過去12ヶ月",
            customLabel: "カスタム範囲",
            startPlaceholder: "開始",
            endPlaceholder: "終了",
        },
        countryChips: {
            title: "マーケット",
            subtitle: "国を選んでダッシュボードの範囲を指定",
            ariaLabel: "フォロー中のマーケット",
            addMarket: "マーケットを追加",
            compare: "比較",
            more: "その他",
            remove: "マーケットを削除",
            comparingNMarkets: "{n} マーケットを比較中 | {n} マーケットを比較中",
            pickMarketsToCompare: "マーケットをクリックして比較",
            multiSelectOff: "複数選択",
            multiSelectOnN: "複数選択 · {n}",
        },
        mapMode: {
            toggleAriaLabel: "マップ表示モード",
            global: "全マーケット",
            intoCountry: "流入",
            outgoing: "流出",
            outgoingHint: "選択した国から進出する企業を表示",
            outgoingDisabledHint: "流出する拡大を見るには、まず国を選択してください",
            backToOverview: "概要に戻る",
            // TODO: translate (placeholders copied from en.js)
            intoCountryHint: "Companies expanding INTO the selected country",
            intoCountryDisabledHint: "Pick a country first to see inbound flow",
        },
        compare: {
            title: "マーケット比較",
            pickMarket: "マーケットを選択",
            emptyHint: "比較するマーケットを追加してください",
            totalCompanies: "追跡中の企業数",
            readyToContact: "連絡可能(着地)",
            newThisMonth: "今月の新規遷移",
            aheadOfPace: "通常ペースを上回る(30日)",
            stageBreakdown: "ステージ内訳",
            landingShareLabel: "準備完了",
            viewMarket: "このマーケットを表示",
            viewMarketAction: "表示",
            addColumn: "マーケットを追加",
            removeColumn: "このマーケットを削除",
            metricHeader: "指標",
            deltaHeader: "Δ",
            winnerBadgeTitle: "選択したマーケット中で最高",
            lensLabel: "比較軸",
            lensVolume: "合計",
            lensShare: "シェア %",
            lensShareHint: "各指標を、そのマーケットの追跡中企業数に対する%として表示",
            insightTitle: "このデータからわかること",
            insightOverall: "{winner}は全{total}指標中{n}指標でリードしています。",
            insightLanding: "{winner}は{loser}より連絡可能な企業を{n}社多く保有しています。",
            insightMomentumMultiple: "{winner}は今月、{loser}の{multiple}倍の速さで新規企業を獲得しています。",
            insightMomentumAbsolute: "{winner}は今月{n}社の新規企業を追加 — {loser}は追加なし。",
            insightPace: "{market}では{n}社が通常より速く動いています — 詳しく確認する価値があります。",
            insightAboveWeight: "{winner}は実力以上の成果 — マーケットの{winnerPct}が連絡可能、{larger}は{largerPct}。",
            dimLanding: "連絡可能",
            dimNewThisMonth: "今月の新規",
            dimAheadOfPace: "通常ペースを上回る",
            dimTotal: "追跡中合計",
            dimTotalShare: "選択中のシェア",
            drillCellTitle: "{country}を開く",
            drillCellTitleStage: "{country}を開く — {stage}ステージ",
            drillSegTitle: "{country}を開く — {stage}({n}社)",
            viewCrossMarket: "{n}マーケットを横断検索",
            summaryWinner: "{winner}は{loser}より連絡可能な企業を{n}社多く保有しています。",
            summaryTie: "両マーケットとも連絡可能な企業数は同じです。",
        },
        countryPicker: {
            title: "マーケットを追加",
            searchPlaceholder: "国名またはコードを検索…",
            noMatch: "検索条件に一致する国はありません。",
        },
        stageTiles: {
            title: "ステージ分布",
            subtitle: "ステージをクリックして下のリストを絞り込み",
            ariaLabel: "拡大ステージ",
            bestToReachOut: "アプローチの最適なタイミング",
            signalsHeading: "判定に使うシグナル",
            signalSoon: "近日",
            infoAria: "このステージの判定方法",
        },
        stage: {
            exploring: "探索",
            exploringDescription: "様子を見ている段階",
            investing: "投資",
            investingDescription: "資金を投入中",
            landing: "着地",
            landingDescription: "現地で立ち上げ中",
            operating: "運用",
            operatingDescription: "本格稼働中",
        },
        signal: {
            ad: "地域ターゲット広告",
            event: "カンファレンス参加",
            news: "ニュース / PR",
            dns: "ドメイン / SSL",
            tech: "プロダクトのローカライズ",
            infra: "クラウド / インフラ",
            ip: "商標 / 特許",
            partner: "パートナーシップ",
            eventPlus: "出展 / 講演",
            reg: "規制ライセンス",
            entity: "法人登記",
            exec: "経営幹部の採用",
            office: "オフィス賃借",
            hire: "現地チーム採用",
            scale: "人員拡大",
            product: "プロダクトリリース",
        },
        signalTier: {
            premier: "プレミア",
        },
        direction: {
            advancing: "進行中",
            steady: "安定",
            retreating: "後退",
            new: "新規",
        },
        freshness: {
            fresh: "新鮮",
            cooling: "鈍化",
            stale: "古い",
            cold: "コールド",
        },
        filters: {
            title: "フィルター",
            clearAll: "すべてクリア",
            direction: "方向",
            freshness: "新鮮度",
            employees: "従業員数",
            industry: "業界",
            risk: "リスク",
            stage: "ステージ",
            scope: "範囲",
            founded: "設立年",
            signalStrength: "シグナル強度",
            onlyAtRisk: "リスクのあるマーケットのみ",
            any: "すべて",
            employeesCustomRange: "カスタム範囲",
            predefinedRange: "定義済み範囲",
            employeesPlaceholder: "規模範囲を選択",
            industrySubCategory: "サブ業界",
            industryCategory: "業界カテゴリー",
            industrySubCategoryPlaceholder: "サブ業界を入力",
            industryCategoryPlaceholder: "業界カテゴリーを入力",
            foundedRange: "設立年",
            foundedFrom: "From",
            foundedTo: "To",
            min: "最小",
            max: "最大",
            // TODO: translate (placeholders copied from en.js)
            signalType: "Signal type",
            pace: "Pace",
            onlyAheadOfPace: "Only ahead of pace",
            paceHint: "Companies whose elapsed first-signal → latest transition sits in the country's fastest quartile.",
            searchPlaceholder: "Search filters…",
            presets: "Filter presets",
            presetsSavedCount: "{n} saved",
            activeOne: "{n} Active filter",
            activeMany: "{n} Active filters",
            save: "Save",
            clearShort: "Clear",
            groupScope: "Scope",
            groupSignal: "Expansion signal",
            groupCompany: "Company profile",
            date: "Date",
            markets: "Markets",
            flowDirection: "Flow direction",
            marketsPlaceholder: "Type a country to scope the dashboard",
            noMatchingFilters: "No filters match",
            addFilter: "Add filter",
            groupRecent: "Recent",
            groupSuggested: "Suggested",
            savedViews: "Saved filters",
            savedViewsCount: "{n} saved",
            noSavedViews: "No saved filters yet.",
            saveCurrentView: "Save current filter",
            deleteView: "Delete filter",
            deleteConfirm: "Delete",
            cancel: "Cancel",
            confirmDeleteView: "Delete the saved filter “{name}”?",
            saveDialogTitle: "Save filter",
            namePrompt: "Name this filter so you can recall it later.",
            namePlaceholder: "e.g. Hot EU SaaS",
            nameRequired: "Give the filter a name.",
            location: "Location",
            locationPlaceholder: "Search country…",
            locationHint: "Filter to companies headquartered in the selected country.",
            revenue: "Revenue",
            revenueRange: "Annual revenue (USD)",
            revenueMin: "Min ($)",
            revenueMax: "Max ($)",
            revenueHint: "Estimated annual revenue range from enrichment data.",
            specialties: "Specialties",
            specialtiesPlaceholder: "Search a specialty…",
            technologies: "Technologies",
            technologiesPlaceholder: "Search a technology…",
            companies: "Companies",
            companiesPlaceholder: "Search a company…",
            activeTitle: "Active",
            activeEmpty: "No filters active",
            dateChipPrefix: "Date",
            marketChipPrefix: "Market",
            savedListChip: "Saved list",
            savedListFilterNote: "Showing one row per company at their highest reached stage. Stage tiles match the list count.",
            originChipPrefix: "From",
            targetChipPrefix: "Into",
            removeFilter: "Remove {label}",
        },
        scope: {
            enteringNewMarket: "新規マーケットに参入",
            expandingWithinPresence: "既存拠点内で拡大",
            establishedOnly: "確立済みのみ",
        },
        signalStrength: {
            high: "高信頼度",
            medium: "中",
            low: "低",
        },
        row: {
            employees: "従業員",
            founded: "設立",
            journey: "ジャーニー",
            journeyLabel: "ジャーニー",
            contractionFlag: "{days}日間新規シグナルなし。この企業は拡大を中断または撤退している可能性があります。",
            noSignalsInDays: "{days}日間新規シグナルなし。この企業は拡大を中断または撤退している可能性があります。",
            movingFast: "高速進行中",
            movingFastDetail: "{months}ヶ月で{stages}。",
            addToSequence: "シーケンスに追加",
            saveToList: "リストに保存",
            viewProfile: "プロフィールを表示",
            viewSignalsHint: "クリックしてすべてのシグナルを表示",
            signalCount: "{n}シグナル",
            distinctTypes: "{n}種類のシグナル",
            stageUpInDays: "ステージアップ · {days}日前",
            stageUpToday: "ステージアップ · 本日",
            newInDays: "新規 · {days}日",
            newToday: "新規 · 本日",
            selectRow: "企業を選択",
            lastSignal: "最新シグナル",
            // TODO: translate (placeholders copied from en.js)
            contractionFlag_leading: "Early signs of contraction — multiple leading indicators (exec departures, layoff chatter) in the last 60 days.",
            contractionFlag_confirming: "Recent contraction signal — a layoff or downsizing was reported in the last 180 days.",
            contractionFlag_lagging: "Confirmed retreat — a market exit, office closure or de-registration in the last 12 months.",
            contractionFlag_leading_mixed: "Mixed signals — early contraction indicators alongside ongoing expansion activity. Watch closely.",
            contractionFlag_confirming_mixed: "Mixed signals — a recent contraction signal sits alongside fresh expansion activity. Confidence is split; review before acting.",
            stageOf: "Stage {n} of {total}",
            tooltipDirection_advancing: "Moved up at least one stage in the last 30 days",
            tooltipDirection_steady: "No stage change in the last 30 days",
            tooltipDirection_retreating: "Fewer recent signals — this company may be pulling back from this market",
            tooltipDirection_new: "Just appeared as a potential expander",
            tooltipFreshness_fresh: "Last signal in the past 30 days",
            tooltipFreshness_cooling: "Last signal 30 to 60 days ago",
            tooltipFreshness_stale: "Last signal 60 to 90 days ago — activity has cooled",
            tooltipFreshness_cold: "No signals in the past 90 days",
            tooltipSignalCount: "Total expansion signals tracked for this company ({n})",
            tooltipDistinctTypes: "{n} different kinds of signal (hiring, news, office lease, etc.)",
            tooltipStageUp: "Recently moved up to the {stage} stage",
            tooltipNew: "First signal detected recently",
            tooltipSignalType: "Signal type: {type}",
        },
        list: {
            title: "{count}社",
            titleAll: "{country}の{count}社",
            titleAllGlobal: "全マーケットの{count}社",
            titleStageScoped: "{stage}の{count}社 — {country}",
            titleStageScopedGlobal: "{stage}の{count}社 — 全マーケット",
            filteredBy: "フィルター条件",
            export: "エクスポート",
            previous: "前へ",
            next: "次へ",
            pageOf: "{total}ページ中{page}ページ",
            selectAll: "すべて選択",
            selectAllOption: "すべて",
            selectThisPage: "このページ",
            selectCustomize: "カスタマイズ",
            selectHint: "この表示から最大{count}社を選択できます。",
            applySelection: "適用",
            selected: "{n}件選択中",
            bulkSequence: "シーケンスに追加",
            bulkSave: "リストに保存",
            bulkExport: "選択をエクスポート",
            findPeople: "人物を検索",
            clearSelection: "クリア",
            paceHint: "{country}の探索 → 着地までの中央値は6ヶ月。{n}社が通常ペースを上回っています。",
            movingFast: "高速進行中",
            movingFastDetail: "4ヶ月で探索 → 運用。{country}のSaaS中央値は6ヶ月。",
            emptyTitle: "この表示に一致する企業はまだありません。",
            emptyBody: "別のマーケットを試すか、新規シグナルの到着をお待ちください。",
            emptyStageTitle: "現在このステージに該当する企業はありません。",
            emptyStageBody: "別のステージを選んで探索を続けましょう。",
            pickCountryTitle: "国を選んで開始してください。",
            pickCountryBody: "上のマーケットチップをクリック(またはマップを使用)してダッシュボードの範囲を指定してください。",
        },
        map: {
            tabWhatsNew: "最新情報",
            whatsNewAriaLabel: "市場動向インサイト",
            whatsNewCaptionCountry: "{country}への進出 · {window}",
            whatsNewCaptionGlobal: "全市場の動向 · {window}",
            whatsNewCaptionMulti: "{n}市場の動向 · {window}",
            whatsNewCorridorHint: "リストを{from} → {to}で絞り込む",
            whatsNewDeltaFlat: "横ばい",
            whatsNewDeltaNew: "新規",
            whatsNewDestinationHint: "{country}にダッシュボードを集中",
            whatsNewEmpty: "選択した期間に遷移はありません。地図コントロールでより広い期間をお試しください。",
            whatsNewFastEmptyBody: "期間を広げるか国フィルターを解除して、ペースを上回る企業を表示してください。",
            whatsNewFastEmptyTitle: "この表示にはペース超過の企業がありません",
            whatsNewFastExplainer: "市場の同業他社の75%より速く進展している企業。",
            whatsNewFastMoversTitle: "ペースを上回る企業",
            whatsNewForYouEmptyBody: "保存した企業でこの期間にステージ遷移はありませんでした。期間を広げるか、後でもう一度ご確認ください。",
            whatsNewForYouEmptyTitle: "リストに新しい動きはありません",
            whatsNewForYouExplainer: "この期間にメンバーが動いた、保存済みの企業リスト。",
            whatsNewFoundedYear: "{year}年設立",
            whatsNewHotCorridors: "注目の回廊",
            whatsNewListCount: "{n}社",
            whatsNewListUpdated: "{time}に更新",
            whatsNewLoading: "集計中…",
            whatsNewMarketsCount: "{n}の新市場",
            whatsNewMarketsInlineMore: "他{n}件",
            whatsNewMovesLabel: "今期の動き",
            whatsNewMovingFastDetail: "{from} → {to}（{months}か月）",
            whatsNewNotableMovers: "注目の動き",
            whatsNewOpenList: "リストを開く：{name}",
            whatsNewOriginHint: "{country}発の企業に絞り込む",
            whatsNewPipelineMix: "ステージ分布",
            whatsNewPrevDay: "昨日",
            whatsNewPrevDays: "過去{n}日",
            whatsNewPrevMonth: "先月",
            whatsNewPrevWeek: "先週",
            whatsNewSavedListMovers: "{count}社に新しい動き",
            whatsNewSavedListMoversAriaLabel: "このリストで{count}社に新しい動き",
            whatsNewSavedListTotal: "計{total}社",
            whatsNewScopeGlobal: "全市場",
            whatsNewScopeMulti: "{n}市場",
            whatsNewStageHint: "{stage}ステージで絞り込む",
            whatsNewStageUpAt: "ステージ上昇 · {time}",
            whatsNewStageVelocity: "ステージ速度",
            whatsNewStoryCool: "{from} → {to}が{delta}%減速",
            whatsNewStoryDeltaDetail: "今期{current}件 vs 前期{previous}件",
            whatsNewStoryMover: "{company}が{stage}に到達",
            whatsNewStoryNew: "{from} → {to}は今期の新しい回廊",
            whatsNewStoryNewDetail: "{n}社が移動を完了 — 初めて記録された回廊",
            whatsNewStoryStageDetail: "{n}社が{stage}に到達",
            whatsNewStoryStageDown: "{stage}ステージの遷移が{delta}%減少",
            whatsNewStoryStageUp: "{stage}ステージの遷移が{delta}%増加",
            whatsNewStorySurge: "{from} → {to}が{delta}%急増",
            whatsNewSurgingDestinations: "急増する目的地",
            whatsNewSurgingOrigins: "急増する起点",
            whatsNewTabFastMovers: "急進企業",
            whatsNewTabForYou: "あなた向け",
            whatsNewTabWideExpanders: "広域拡大",
            whatsNewUnnamedList: "無題のリスト",
            whatsNewVelocityDetail: "前回の{window}は{previous}社",
            whatsNewVelocityDetailNoPrior: "有効な活動の初回期間",
            whatsNewVelocityTitle: "今期{n}社が{verb}",
            whatsNewVerbAcross: "追跡されたクロスボーダーの動き",
            whatsNewVerbInto: "{scope}へ進出",
            whatsNewViewAll: "リスト内のすべての企業を表示",
            whatsNewViewAllN: "{n}社すべてを表示",
            whatsNewViewList: "企業リスト全体を表示",
            whatsNewVsPrev: "{label}の{n}件と比較",
            whatsNewWhereFrom: "主な起点",
            whatsNewWideEmptyBody: "期間を広げるか国フィルターを解除して、一度に多くの市場へ進出する企業を表示してください。",
            whatsNewWideEmptyTitle: "この表示には広域拡大企業がありません",
            whatsNewWideExplainer: "一度に3つ以上の新市場へ進出した企業 — 積極的な多国展開。",
            whatsNewWindowDays: "過去{n}日",
            whatsNewWindowMonth: "過去30日",
            whatsNewWindowToday: "今日",
            whatsNewWindowWeek: "過去7日",
            placeholderAriaLabel: "拡大ワールドマップ",
            loadingBasemap: "ベースマップを読み込み中…",
            loadingCountry: "マーケットデータを読み込み中…",
            loadingDashboard: "拡大データを読み込み中…",
            newThisMonthIn: "{country}の今月の新規",
            newTransitionsAllMarkets: "今月の新規遷移",
            readyToContact: "連絡可能",
            tracked: "追跡中合計",
            activeMarkets: "アクティブな市場",
            ctaReadyToContact: "連絡可能な{n}社を表示",
            origins: {
                title: "上位の起点 → {country}",
                total: "{n}件のクロスボーダー",
                domestic: "+{n}件の国内({country} → {country})",
                untracked: "+{n}件の未追跡起点",
                empty: "このマーケットの起点データはまだありません。",
                plusMore: "+他{n}件の起点",
                clearFilter: "起点フィルターをクリア",
            },
            timeFilterLabel: "シグナル期間",
            timeFilterToday: "今日",
            timeFilterWeek: "今週",
            timeFilterMonth: "今月",
            timeFilterAll: "全期間",
            activityFeedTitle: "新着情報",
            activityFeedEmpty: "選択した期間に新しいアクティビティはありません。",
            activityFeedFooter: "すべてのアクティビティを表示 →",
            activityFeedAdvanced: "{stage}に到達",
            activityFeedNew: "新規シグナルを検出",
            activityFeedFrom: "{country}発",
            activityFeedTitleHint: "クリックで企業詳細を表示",
            activityFeedTitleHintCountry: "クリックでこの市場に絞り込み",
            marketIntelTitle: "マーケットインテル",
            tabOrigins: "上位起点",
            tabActivity: "最近の動き",
            showActivity: "マーケットインテルを表示",
            hideActivity: "マーケットインテルを非表示",
            windowEmptyBody: "期間を広げると、この企業の活動が表示されます。",
      noActivityTitle: "この表示にはまだ動きがありません。",
            noActivityBody: "別のマーケットを選ぶか、グローバルフローに切り替えてください。",
            noOutgoingTitle: "{country}からの流出シグナルはまだありません",
            noOutgoingBody: "現在のデータでは、{country}から進出している企業は検出されていません。代わりに、選択中マーケット表示に切り替えて、この国へ進出している企業をご覧ください。",
            noOutgoingCta: "このマーケットへ進出している企業を表示",
            companiesCount: "{n}社 | {n}社",
            newThisMonthCount: "今月{n}件の新規",
            clickHint: "マーケットにホバーで詳細表示 · クリックでドリルダウン",
            zoomIn: "ズームイン",
            zoomOut: "ズームアウト",
            resetView: "表示をリセット",
            densityShowN: "最大 {n} マーケット | 最大 {n} マーケット",
            densitySliderAriaLabel: "マップ密度 — スライドで表示する起点の数を調整",
            legendAriaLabel: "マップの凡例",
            legendTitle: "ステージ",
            legendSectionRecent: "最近の動き",
            legendStageUp: "進行中",
            legendStageUpTitle: "シアンのリングは過去30日以内にステージが進んだ国を示します",
            legendNew: "新規",
            legendNewTitle: "光るドットは過去90日以内に拡大を開始した国を示します",
            legendBadge30d: "30日",
            legendBadge90d: "90日",
            legendCollapse: "凡例を最小化",
            legendExpand: "凡例を表示",
            companies: "社",
            // TODO: translate (placeholders copied from en.js)
            activityFeedEmptyGlobal: "Pick a market above to see companies that just moved stages.",
        },
        tooltip: {
            signals: "シグナル",
            companiesMoving: "社が動いています",
            companiesExpandingFrom: "社がここから進出中",
            companiesArrivingAt: "社がこの起点から到着",
        },
        popover: {
            close: "閉じる",
            loading: "詳細を読み込み中…",
            loadFailed: "このマーケットを読み込めませんでした。",
            keyMoments: "重要な瞬間",
            signals: "シグナル({n})",
            firstSignal: "最初のシグナル",
            latestSignal: "最新のシグナル",
            reachedStage: "{stage}に到達",
            stageUp: "ステージアップ",
        },
        drawer: {
            title: "企業の拡大プロフィール",
            currentStage: "現在のステージ",
            confidence: "信頼度",
            confidenceHigh: "高",
            confidenceMedium: "中",
            confidenceLow: "低",
            signalGeneric: "シグナル",
            allSignals: "シグナルタイムライン",
            signalsCount: "{n}シグナル",
            noSignals: "このマーケットペアの詳細シグナルはまだ記録されていません。",
            contractionBanner: "縮小シグナルを検出 — アプローチ前にこの企業がまだ拡大中かを確認してください。",
            openFullProfile: "完全なプロフィールを開く",
            visitWebsite: "ウェブサイトを訪問",
            // Expansion context (route between hero card and stage strip)
            expandingInto: "進出先",
            expandingFrom: "起点",
            expansionTo: "拡大先",
            signalsInMarket: "シグナル(",
            // Company overview tile
            companyAtAGlance: "企業概要",
            industry: "業界",
            founded: "設立",
            employees: "従業員数",
            headquarters: "本社",
            website: "ウェブサイト",
            // Presence section
            onTheGround: "現地展開",
            presenceOffice: "オフィス",
            presenceLegal: "法人",
            presenceHiring: "採用中",
            // TODO: translate
            milestoneActiveRoles: "Reached {n} active role | Reached {n} active roles",
            milestoneScale: "Reached open-roles threshold",
            // Other markets
            alsoExpandingTo: "他に進出中の市場",
            noOtherMarkets: "他のマーケットはまだ検出されていません。",
            showAll: "すべて表示({n})",
            showLess: "折りたたむ",
            filterAll: "すべて",
            // Pace
            paceLabel: "拡大ペース",
            paceText: "最初のシグナルから{stage}まで{days}日",
            paceFast: "速い",
            paceTypical: "通常",
            paceSlow: "遅い",
            // Signal labels
            signalSource: "{source}経由",
            signalTierHint: "入手困難なインテリジェンスを Pubrio が発掘",
            signalSourceFrom: "{source}経由 · {host}",
            signalViewSource: "ソースを表示",
            signalNoEvidence: "ソースリンクはありません",
            // Footer note
            poweredBy: "最新検出シグナル",
            // TODO: translate (placeholders copied from en.js)
            signalsCountOf: "{n} of {total} signals",
            loadMore: "Load more signals",
            switchMarket: "Switch market",
            durationDays: "{n}d",
            durationWeeks: "{n}w",
            durationMonths: "{n}mo",
            durationYears: "{n}y",
            reachedStageAt: "Reached {stage} {when}",
            transitionDuration: "{duration} in {prev}",
            signalGroupTitle: "{n} × {type}",
            signalGroupContext: "{items}",
            headcountScalingTitle: "{n} jobs currently open",
            recentSignalsChip: "{n} {type} · 12w",
            activityLabel: "Activity",
            activityWindow: "{weeks} weeks",
            activityTotal: "All",
            activityFilterByType: "Filter timeline to {type}",
            activityCellTooltip: "{n} × {type} · {week}",
            activityCellMore: "+{n} more",
            activityCellEmpty: "No {type} signals · {week}",
            activityEmpty: "Quiet for now",
            activityEmptyHint: "No signals detected in the last 12 weeks — this company's expansion engine is paused or pre-launch.",
            snapshotLabel: "Current snapshot",
            showItems: "Show {n}",
            showItemsOf: "Show {n} of {total}",
            hideItems: "Hide",
            loadingMore: "Loading…",
        },
        live: {
            title: "マーケットアップデート",
            live: "ライブ",
            all: "すべて",
            advancing: "進行中",
            retreating: "後退",
            tabNews: "ニュース",
            tabFunding: "資金調達インサイト",
            tabJobs: "求人情報",
            tabAds: "広告",
            sort: "並び替え",
            sortNewest: "新しい順",
            sortOldest: "古い順",
            sortImpact: "インパクト順",
            filter: "フィルター",
            findPeople: "人物を検索",
            searchPlaceholder: "検索…",
            pendingBanner: "前回のアクセスから{n}件の新着記事 · クリックして読み込み",
            empty: "遷移はまだありません — 企業が動き始めるとここに表示されます。",
            lastHour: "過去1時間",
            advanced: "進行先",
            retreated: "後退元",
            decayed: "減衰元",
            changed: "遷移先",
        },
        trending: {
            title: "トレンド企業",
            mostActiveToday: "本日最もアクティブ",
            catAll: "すべて",
            catTechnology: "テクノロジー",
            catFintech: "フィンテック",
            catHealthcare: "ヘルスケア",
            catSaaS: "SaaS",
            more: "その他",
            empty: "トレンド企業はまだありません。",
        },
        toast: {
            sequenceQueued: "シーケンスに追加を起動しました — ポップアップからシーケンスを選択してください。",
            savedToList: "{name}をリストに保存しました。",
            saveFailed: "リストに保存できませんでした。再試行してください。",
            exportReady: "{n}件をエクスポートしました。",
            exportFailed: "エクスポートに失敗しました — 小さなバッチで再試行してください。",
        },
        export: {
            title: "拡張データをCSVにエクスポート",
            body: "{count}件をCSVにエクスポートするには{price}クレジットが必要です。",
        },
        widgetRail: {
            title: "その他のウィジェット",
            expandHint: "クリックで展開",
        },
        errors: {
            loadFailed: "拡大データを読み込めませんでした。",
            retry: "再試行",
        },
        time: {
            unknown: "—",
            today: "本日",
            daysAgo: "{n}日前",
            weeksAgo: "{n}週間前",
            monthsAgo: "{n}ヶ月前",
            yearsAgo: "{n}年前",
        },
    },
};